import actions from "./actions";

const initState = {
    events: [],
    errors: {},
    loading: false,
}

export default function eventTypesReducer(state = initState, action) {
    switch(action.type) {
        case actions.FETCH_EVENT_TYPES: 
            return {
                ...state,
                loading: true,
            };
        case actions.FETCH_EVENT_TYPES_SUCCESS:
            const sortedEvents = action.events.sort((a,b) => a.name.localeCompare(b.name))
            return {
                ...state,
                events: sortedEvents,
                loading: false,
            };
        case actions.FETCH_EVENT_TYPES_ERROR:
            return {
                ...state,
                events: [],
                loading: false,
            };
        default:
            return state;
    }
}
